export const BASE_SEPOLIA_FAUCET_URL = `https://portal.cdp.coinbase.com/onchain-tools/faucet?token=ETH&network=base-sepolia`;

export const SOLANA_DEVNET_FAUCET_URL = `https://portal.cdp.coinbase.com/onchain-tools/faucet?token=SOL&network=solana-devnet`;
